/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var isRTL=function(r){if(r){if(r.dir!==""){return r.dir.toLowerCase()==="rtl"}}return(document===null||document===void 0?void 0:document.dir.toLowerCase())==="rtl"};export{isRTL as i};